/**
 * Orb and cluster defaults for the interpretation payload (spec §8).
 * Tune against the five golden corpus charts before treating as locked.
 */

/** Conjunction orb for North/South Node hits (catalyst, past mastery). Includes angles. */
export const nodeConjunctOrb = 10;

/** Square orb to NN or SN longitude (skipped steps). */
export const nodeSquareOrb = 8;

/** Conjunction orb for ASC / DSC / MC / IC hits. */
export const angleConjunctOrb = 8;

/** Conjunction orb for bodies conjunct Pluto. */
export const plutoConjunctOrb = 8;

/** Minimum bodies in the same sign or same house to count as a stellium. */
export const stelliumMinBodies = 3;

/** Optional max span (degrees) for a same-sign stellium cluster. */
export const stelliumMaxSpan = 30;

/** @typedef {typeof DEFAULT_ORBS} OrbConfig */

export const DEFAULT_ORBS = Object.freeze({
  nodeConjunctOrb,
  nodeSquareOrb,
  angleConjunctOrb,
  plutoConjunctOrb,
  stelliumMinBodies,
  stelliumMaxSpan,
});
